/**
 * @author: subhasish.ghosh@zoom.us
 */

import { SET_AUTHENTICATION } from "../actions/authActions";

const initialState = {
  isAuthenticated: false, // assuming the user is NOT authenticated by default
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTHENTICATION:
      return {
        ...state,
        isAuthenticated: action.payload,
      };
    default:
      return state;
  }
};

export default authReducer;
